// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import CryptoJS from 'crypto-js';
import { getSession } from './sessionstore';

export async function encryptHeader(headerValue) {
    // Issued by the server at login and valid only for that session, so no
    // long-lived key ships in this bundle.
    const secretKey = getSession("session_key");
    if (!secretKey) {
        throw new Error("Missing session key");
    }
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(headerValue, CryptoJS.enc.Hex.parse(secretKey), {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    return {
        encryptedHeader: encrypted.toString(),
        iv: iv.toString()
    };
}
